import {createStore, applyMiddleware, compose} from 'redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import root_reducer from './root_reducer'
import {DEBUG} from '../util'

const initialState = {}
const middleware = [
  thunk,
  DEBUG && logger,
]

const persist_config = {
  key: 'root',
  storage,
  whitelist: ['config']
}

export default () => {
  const store = createStore(
    persistReducer(persist_config, root_reducer),
    initialState,
    compose(
      applyMiddleware(...middleware.filter(Boolean)),
    )
  )
  const persistor = persistStore(store)
  return {store, persistor}
}
